import { render, staticRenderFns } from "./CreateSingleBrandDashboard.vue?vue&type=template&id=d07c6754&scoped=true&"
import script from "./CreateSingleBrandDashboard.vue?vue&type=script&lang=js&"
export * from "./CreateSingleBrandDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CreateSingleBrandDashboard.vue?vue&type=style&index=0&id=d07c6754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07c6754",
  null
  
)

export default component.exports